import { createFileRoute } from '@tanstack/react-router';

import { redirectToOnboardingResumeStep } from '@/features/onboarding/route-guards';

export const Route = createFileRoute('/onboarding/')({
    beforeLoad: redirectToOnboardingResumeStep
});
